// extracted by mini-css-extract-plugin
export default {"codingWorkSection":"CodingWork_codingWorkSection__LfwaH","codingWorkGalleryHolder":"CodingWork_codingWorkGalleryHolder__00aEf"};